import { render, staticRenderFns } from "./CmgMealBuilder.vue?vue&type=template&id=cc95a6fe&scoped=true&lang=pug"
import script from "./cmg-meal-builder.ts?vue&type=script&lang=ts&external"
export * from "./cmg-meal-builder.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgMealBuilder.vue?vue&type=style&index=0&id=cc95a6fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc95a6fe",
  null
  
)

export default component.exports